module.exports = __webpack_public_path__ + "img/des_kalinba_2.714b96f5.jpg";